import { Alert, Select, Tag, Table, Tooltip, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import currencyFormatter from '../../Utils/currencyFormatter';
import StatusBar from './StatusBar';

const Dato = ({ etiqueta, ancho, children }) => (
  <div className="detalle-dato" style={ancho ? { gridColumn: '1 / -1' } : undefined}>
    <div className="detalle-etiqueta">{etiqueta}</div>
    <div className="detalle-valor">{children}</div>
  </div>
);
Dato.propTypes = { etiqueta: PropTypes.node, ancho: PropTypes.bool, children: PropTypes.node };

const Seccion = ({ titulo, children }) => (
  <section className="detalle-seccion">
    <h2 className="detalle-seccion__titulo">{titulo}</h2>
    {children}
  </section>
);
Seccion.propTypes = { titulo: PropTypes.string, children: PropTypes.node };

export default function FormDetalleGasto({
  expenseDetail,
  handleUpdateCompany,
  handleEventualWeekend,
  handleUpdatePay,
  showModalAmount,
  showModalExcess,
  openFileExcess,
  openFileSurplus,
  openFileMissing,
  payments,
  payment,
  changePayment,
  handlePostChangePayment,
  isNormal,
  isShopping,
  isAdquision,
  isAdmin,
  isCancel,
  isPurchaseOrder,
  isReceived,
  isDevolution,
  isDevolutionReturn,
  decodedToken,
  isUser,
  columns,
  navigate,
  isSuperAdmin,
  id,
  archivo,
  acciones
}) {
  // Avisos informativos según rol y etapa
  const aviso =
    expenseDetail?.approved_status !== 'rechazada' &&
    isUser &&
    expenseDetail?.purchase_table_name === 'pedido-en-proceso' ? (
      <Alert
        message="Una vez generada la 'SOLICITUD DE GASTO' ya no puedes hacer ningún cambio, en caso de alguna equivocación pide a tú 'JEFE DIRECTO' que deniegue la solicitud y genera una nueva."
        type="warning"
        showIcon
        closable
      />
    ) : (isShopping || isAdquision) &&
      isCancel &&
      expenseDetail?.payment_method === 'SIN MÉTODO DE PAGO' &&
      isPurchaseOrder ? (
      <Alert
        message="Una vez hayas actualizado el método de pago, podrás confirmar la compra."
        type="info"
        showIcon
        closable
      />
    ) : decodedToken?.role?.name !== 'caja_chica' &&
      isCancel &&
      expenseDetail?.type_status !== 'devolución' &&
      expenseDetail?.purchase_table_name === 'pedido-entregado' ? (
      <Alert
        message="Rectifica que tú producto este en buen estado o que el servicio se cumplio correctamente, 
                si no es asi pide al comprador que deseas realizar la devolución."
        type="info"
        showIcon
        closable
      />
    ) : (isShopping || isAdquision) &&
      isUser &&
      isCancel &&
      expenseDetail?.purchase_table_name === 'pedido-entregado' ? (
      <Alert
        message="Rectifica que el producto este en buen estado o que el servicio se cumplio correctamente, 
                si es así, presentate con la persona que realizo la 'SOLICITUD DE GASTO' para ver si cumple con sus condiciones,
                de lo contrario realiza la devolución."
        type="info"
        showIcon
        closable
      />
    ) : null;

  const hayPanel = !!(aviso || archivo || acciones);
  const sinMetodo = expenseDetail?.payment_method === 'SIN MÉTODO DE PAGO';
  const puedeGestionar = isShopping || isAdquision || isSuperAdmin || isAdmin;
  const nombreGasto = expenseDetail?.spent && expenseDetail?.spent[0]?.spent_name;
  const estadoSolicitud = (
    <>
      {isNormal && expenseDetail?.approved_status === 'pendiente' && (
        <Tag color="geekblue">EN PROCESO</Tag>
      )}
      {expenseDetail?.approved_status === 'en aprobación por administrador' && isNormal && (
        <Tag color="geekblue">EN PROCESO</Tag>
      )}
      {expenseDetail?.approved_status === 'rechazada' && <Tag color="error">RECHAZADA</Tag>}
      {isNormal && expenseDetail?.purchase_table_name === 'pedido-entregado' && (
        <Tag color="gold">POR ENTREGAR</Tag>
      )}
      {expenseDetail?.approved_status === 'aprobada' &&
        isNormal &&
        expenseDetail?.purchase_table_name === 'pedido-recibido' && (
          <Tag color="success">RECIBIDO</Tag>
        )}
      {isDevolution && expenseDetail?.type_status === 'en proceso' && isDevolutionReturn && (
        <Tag color="gold">DEVOLUCIÓN EN PROCESO</Tag>
      )}
      {isDevolution && expenseDetail?.type_status === 'rechazada' && isDevolutionReturn && (
        <Tag color="red">DEVOLUCIÓN RECHAZADA</Tag>
      )}
      {isDevolution && isNormal && isDevolutionReturn && (
        <Tag color="magenta">DEVOLUCIÓN COMPLETA</Tag>
      )}
      {expenseDetail?.purchase_table_name === 'pedido-en-compra' && isNormal && (
        <Tag color="purple">ADQUISICIÓN</Tag>
      )}
      {expenseDetail?.purchase_table_name === 'pedido-en-compra' &&
        expenseDetail?.type_status === 'cancelado' && <Tag color="error">RECHAZADO</Tag>}
    </>
  );

  const estadoConfirmacion = (estado) => (
    <Tag color={estado === 'Sin confirmar' ? 'error' : 'success'} style={{ marginInlineEnd: 0 }}>
      {estado}
    </Tag>
  );

  return (
    <div className="detalle-gasto">
      <header className="detalle-encabezado">
        <button
          type="button"
          className="detalle-volver"
          onClick={() => navigate(-1)}
          aria-label="Volver">
          <ArrowLeftOutlined aria-hidden="true" />
        </button>
        <h1 className="detalle-titulo">Detalle de la solicitud</h1>
        <span className="detalle-id">GTO-{id}</span>
        <span className="detalle-estado">{estadoSolicitud}</span>
      </header>

      {expenseDetail?.purchase_table_name ? (
        <StatusBar
          status={expenseDetail.purchase_table_name}
          substatus={expenseDetail.type_status || ''}
          approved={expenseDetail.approved_status || ''}
        />
      ) : null}

      <div className={hayPanel ? 'detalle-cuerpo' : 'detalle-cuerpo detalle-cuerpo--solo'}>
        <div className="detalle-principal">
          <Seccion titulo="Solicitud">
            <div className="detalle-datos">
              <Dato etiqueta="Nombre completo">{expenseDetail?.user_name}</Dato>
              <Dato etiqueta="Empresa">
                {expenseDetail?.company && expenseDetail.company[0]?.company_name}
              </Dato>
              <Dato etiqueta="Centro de costos">
                {expenseDetail?.center && expenseDetail?.center[0].center_name}
              </Dato>
              <Dato etiqueta="Concepto" ancho>
                {nombreGasto}
              </Dato>
              <Dato etiqueta="Descripción de la necesidad" ancho>
                {expenseDetail?.description}
              </Dato>
            </div>
          </Seccion>

          {expenseDetail?.event && expenseDetail.event.length > 0 ? (
            <Seccion titulo="Eventuales">
              <Table
                columns={columns}
                dataSource={expenseDetail.event.map((event) => ({
                  key: uuidv4(),
                  name: event.name,
                  pay: event.pay,
                  company_name: event.company_name
                }))}
                pagination={{
                  position: ['bottomCenter'],
                  defaultPageSize: 3
                }}
              />
              {nombreGasto !== 'EVENTUALES' ? (
                <Tooltip title="Haz clic aquí si la empresa de algún eventual es incorrecta o 'Sin definir'">
                  <Typography.Link onClick={handleUpdateCompany}>
                    Actualizar empresa eventuales
                  </Typography.Link>
                </Tooltip>
              ) : null}
            </Seccion>
          ) : null}
          {expenseDetail?.spent &&
          nombreGasto === 'EVENTUALES FIN DE SEMANA' &&
          expenseDetail.event.length === 0 ? (
            <Seccion titulo="Eventuales">
              <Dato etiqueta="Eventuales">
                SIN DEFINIR{' '}
                <Tooltip title="Haz clic aquí si no registraste eventuales">
                  <Typography.Link className="ml-2" onClick={handleEventualWeekend}>
                    Registrar Eventuales
                  </Typography.Link>
                </Tooltip>
              </Dato>
            </Seccion>
          ) : null}

          <Seccion titulo="Pago">
            <div className="detalle-datos">
              <Dato etiqueta="Método de pago">
                {puedeGestionar && expenseDetail?.type_status === 'normal' && isPurchaseOrder ? (
                  sinMetodo ? (
                    <>
                      <Select
                        style={{
                          width: '240px',
                          maxWidth: '100%'
                        }}
                        placeholder="Selecciona el método"
                        options={payments}
                        required
                        onChange={changePayment}
                        mode="single"
                        value={payment}
                      />
                      <div className="mt-1">
                        <Tooltip title="Haz clic para actualizar el método de pago">
                          <Typography.Link onClick={handlePostChangePayment}>
                            Actualizar método de pago
                          </Typography.Link>
                        </Tooltip>
                      </div>
                    </>
                  ) : (
                    expenseDetail?.payment_method
                  )
                ) : (
                  expenseDetail?.payment_method
                )}
              </Dato>
              <Dato etiqueta="Importe">
                <span className="detalle-importe">{currencyFormatter(expenseDetail?.total)}</span>
                <div className="mt-1">
                  {!sinMetodo &&
                  expenseDetail?.spent &&
                  puedeGestionar &&
                  expenseDetail?.purchase_table_name !== 'pedido-en-proceso' &&
                  (nombreGasto === 'EVENTUALES MAQUILA' || nombreGasto === 'EVENTUALES') ? (
                    <Tooltip title="Haz clic aquí si el importe de algún eventual es incorrecto">
                      <Typography.Link onClick={handleUpdatePay}>
                        Actualizar pago eventuales
                      </Typography.Link>
                    </Tooltip>
                  ) : puedeGestionar &&
                    !sinMetodo &&
                    nombreGasto !== 'EVENTUALES FIN DE SEMANA' &&
                    isCancel &&
                    isPurchaseOrder ? (
                    <Tooltip title="Actualiza el importe de pago en caso de que el precio haya cambiado al momento de la compra">
                      <Typography.Link onClick={showModalAmount}>Actualizar pago</Typography.Link>
                    </Tooltip>
                  ) : isReceived &&
                    isUser &&
                    expenseDetail?.returnmoney?.length === 0 &&
                    expenseDetail?.payment_method === 'EFECTIVO' &&
                    nombreGasto !== 'EVENTUALES' &&
                    nombreGasto !== 'EVENTUALES FIN DE SEMANA' &&
                    nombreGasto !== 'EVENTUALES MAQULA' ? (
                    <Tooltip title="Haz clic aquí si posees algún excedente de efectivo">
                      <Typography.Link onClick={showModalExcess}>
                        ¿Posees algún excedente de efectivo?
                      </Typography.Link>
                    </Tooltip>
                  ) : null}
                </div>
              </Dato>
            </div>
          </Seccion>

          {!Array.isArray(expenseDetail?.returnmoney) && expenseDetail?.returnmoney ? (
            <Seccion titulo="Devolución de excedente">
              <div className="detalle-datos">
                <Dato etiqueta="Devuelto por">{expenseDetail.returnmoney.return_user_id}</Dato>
                <Dato etiqueta="Importe al ingresar la solicitud">
                  {`$${expenseDetail.returnmoney.previous_total}`}
                </Dato>
                <Dato etiqueta="Importe devuelto">
                  {expenseDetail.returnmoney.total_return &&
                    `$${expenseDetail.returnmoney.total_return}`}
                </Dato>
                <Dato etiqueta="Motivo">{expenseDetail.returnmoney.description}</Dato>
                <Dato etiqueta="Fecha y hora">{expenseDetail.returnmoney.created_at}</Dato>
                <Dato etiqueta="Estado de recibido">
                  {estadoConfirmacion(expenseDetail.returnmoney.status)}
                  {expenseDetail.returnmoney.file_exchange_returns && (
                    <div className="mt-1">
                      <a onClick={openFileExcess}>Comprobante</a>
                    </div>
                  )}
                </Dato>
                {expenseDetail.returnmoney.status === 'Confirmado' && (
                  <>
                    <Dato etiqueta="Confirmado por">
                      {expenseDetail.returnmoney.confirmation_user_id}
                    </Dato>
                    <Dato etiqueta="Fecha y hora de confirmación">
                      {expenseDetail.returnmoney.confirmation_datetime}
                    </Dato>
                  </>
                )}
              </div>
            </Seccion>
          ) : null}

          {!Array.isArray(expenseDetail?.lessmoneyeventual) && expenseDetail?.lessmoneyeventual ? (
            <Seccion titulo="Entrega de sobrante">
              <div className="detalle-datos">
                <Dato etiqueta="Solicitante">
                  {expenseDetail.lessmoneyeventual.id_applicant_person}
                </Dato>
                <Dato etiqueta="Importe al ingresar la solicitud">
                  ${expenseDetail.lessmoneyeventual.previous_total}
                </Dato>
                <Dato etiqueta="Importe actualizado">
                  ${expenseDetail.lessmoneyeventual.current_total}
                </Dato>
                <Dato etiqueta="Motivo">{expenseDetail.lessmoneyeventual.description}</Dato>
                <Dato etiqueta="Fecha y hora del registro de eventuales">
                  {expenseDetail.lessmoneyeventual.created_at}
                </Dato>
                <Dato etiqueta="Estado de entrega">
                  {estadoConfirmacion(expenseDetail.lessmoneyeventual.status)}
                  <div className="mt-1">
                    <a onClick={openFileSurplus}>Comprobante</a>
                  </div>
                </Dato>
                {expenseDetail.lessmoneyeventual.status === 'Confirmado' && (
                  <>
                    <Dato etiqueta="Confirmado por">
                      {expenseDetail.lessmoneyeventual.id_person_who_delivers}
                    </Dato>
                    <Dato etiqueta="Fecha y hora de confirmación">
                      {expenseDetail.lessmoneyeventual.confirmation_datetime}
                    </Dato>
                  </>
                )}
              </div>
            </Seccion>
          ) : null}

          {!Array.isArray(expenseDetail?.moremoneyeventual) && expenseDetail?.moremoneyeventual ? (
            <Seccion titulo="Entrega de faltante">
              <div className="detalle-datos">
                <Dato etiqueta="Solicitante">
                  {expenseDetail.moremoneyeventual.id_applicant_person}
                </Dato>
                <Dato etiqueta="Importe al ingresar la solicitud">
                  ${expenseDetail.moremoneyeventual.previous_total}
                </Dato>
                <Dato etiqueta="Importe actualizado">
                  ${expenseDetail.moremoneyeventual.current_total}
                </Dato>
                <Dato etiqueta="Motivo">{expenseDetail.moremoneyeventual.description}</Dato>
                <Dato etiqueta="Fecha y hora del registro de eventuales">
                  {expenseDetail.moremoneyeventual.created_at}
                </Dato>
                <Dato etiqueta="Estado de entrega">
                  {estadoConfirmacion(expenseDetail.moremoneyeventual.status)}
                  <div className="mt-1">
                    <a onClick={openFileMissing}>Comprobante</a>
                  </div>
                </Dato>
                {expenseDetail.moremoneyeventual.status === 'Confirmado' && (
                  <>
                    <Dato etiqueta="Confirmado por">
                      {expenseDetail.moremoneyeventual.id_person_who_delivers}
                    </Dato>
                    <Dato etiqueta="Fecha y hora de confirmación">
                      {expenseDetail.moremoneyeventual.confirmation_datetime}
                    </Dato>
                  </>
                )}
              </div>
            </Seccion>
          ) : null}
        </div>

        {hayPanel ? (
          <aside className="detalle-panel" aria-label="Avisos y acciones">
            {aviso}
            {archivo}
            {acciones ? <div className="detalle-acciones">{acciones}</div> : null}
          </aside>
        ) : null}
      </div>
    </div>
  );
}

FormDetalleGasto.propTypes = {
  expenseDetail: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  handleUpdateCompany: PropTypes.func,
  handleEventualWeekend: PropTypes.func,
  handleUpdatePay: PropTypes.func,
  showModalAmount: PropTypes.func,
  showModalExcess: PropTypes.func,
  openFileExcess: PropTypes.func,
  openFileSurplus: PropTypes.func,
  openFileMissing: PropTypes.func,
  payments: PropTypes.array,
  payment: PropTypes.number,
  changePayment: PropTypes.func,
  handlePostChangePayment: PropTypes.func,
  isNormal: PropTypes.bool,
  isShopping: PropTypes.bool,
  isAdquision: PropTypes.bool,
  isCancel: PropTypes.bool,
  isPurchaseOrder: PropTypes.bool,
  isReceived: PropTypes.bool,
  isDevolution: PropTypes.bool,
  isDevolutionReturn: PropTypes.bool,
  isAdmin: PropTypes.bool,
  decodedToken: PropTypes.object,
  selectedDate: PropTypes.object,
  isUser: PropTypes.bool,
  columns: PropTypes.array,
  navigate: PropTypes.func,
  isSuperAdmin: PropTypes.bool,
  id: PropTypes.string,
  archivo: PropTypes.node,
  acciones: PropTypes.node
};
